import { defineComponent, useListeners, ref, computed } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiName",
  props: {
    name: { type: String, required: true },
    showTooltip: { type: Boolean, required: false, default: true }
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const hasLinkClickListener = ref(Object.prototype.hasOwnProperty.call(listeners, "click"));
    const title = computed(() => props.showTooltip ? props.name : void 0);
    const onLinkClick = () => {
      emits("click");
    };
    return { __sfc: true, listeners, emits, props, hasLinkClickListener, title, onLinkClick };
  }
});

export { _sfc_main as default };
